export enum WebsocketMessageType {
    CREATE = 'CREATE',
    CHANGE = 'CHANGE',
    UPDATE = 'UPDATE',
    ADD = 'ADD',
    REMOVE = 'REMOVE',
    ERROR = 'ERROR'
}

export type WebsocketError = {
    message: string
    errorCode: number
}

export type WebsocketMessage<T extends unknown> = {
    type:
        | WebsocketMessageType.CREATE
        | WebsocketMessageType.CHANGE
        | WebsocketMessageType.UPDATE
        | WebsocketMessageType.ADD
        | WebsocketMessageType.REMOVE
    sessionID?: string
    data: T
}

export type WebsocketErrorMessage = {
    type: WebsocketMessageType.ERROR
    data: WebsocketError
}
